import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "No membership fees",
    body: "The club is free — forever. You only ever pay for the wine you actually want. No dues, no fine print, no gotchas.",
  },
  {
    n: "02",
    title: "Bottles you won't find in stores",
    body: "Small-batch, unlabeled finds, hand-picked by people who taste everything first. If it's ordinary, it doesn't ship.",
  },
  {
    n: "03",
    title: "Skip, swap or cancel anytime",
    body: "Life changes; your wine should keep up. Pass on a month, trade a bottle, or walk away — no phone calls, no guilt.",
  },
  {
    n: "04",
    title: "Great value on every shipment",
    body: "Member pricing on every bottle, every time. The good stuff shouldn't need a special occasion budget.",
  },
];

const Chapter = ({ c, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
    className="border-t border-ink/15 pt-8"
    data-testid={`manifesto-chapter-${c.n}`}
  >
    <span className="font-serif text-sm italic text-wine">{c.n}</span>
    <h3 className="mt-4 font-serif text-2xl tracking-tight md:text-3xl">{c.title}</h3>
    <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink/65">{c.body}</p>
  </motion.div>
);

export const Manifesto = () => (
  <section id="manifesto" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-36" data-testid="manifesto-section">
    <div className="grid grid-cols-1 gap-16 md:grid-cols-[1fr_1.6fr]">
      <div className="md:sticky md:top-32 md:self-start">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-serif text-4xl tracking-tight md:text-5xl"
        >
          The Unlabeled <em className="text-wine">manifesto</em>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 max-w-xs text-sm leading-relaxed text-ink/60"
        >
          Four promises, printed in ink. This is what membership means here.
        </motion.p>
        <motion.img
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
          src="https://images.pexels.com/photos/29436323/pexels-photo-29436323.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Red wine being poured"
          className="mt-10 hidden aspect-[3/4] w-64 object-cover md:block"
          style={{ clipPath: "polygon(0 0, 100% 4%, 96% 100%, 0 96%)" }}
        />
      </div>
      <div className="grid grid-cols-1 gap-x-12 gap-y-16 sm:grid-cols-2">
        {chapters.map((c, i) => (
          <Chapter key={c.n} c={c} i={i} />
        ))}
      </div>
    </div>
  </section>
);
